module.exports = __webpack_public_path__ + "media/images/cipd-02e1dc25e6d0a184c64f4e0d9f462a8d.svg";